// extracted by mini-css-extract-plugin
module.exports = {"backButtonWrapper":"PageTitle_backButtonWrapper__aFCCj","line":"PageTitle_line__V6ADJ"};